export default __webpack_public_path__ + "static/media/tags.a734568d.svg";